module.exports = __webpack_public_path__ + "img/info-uploaded.e5835bf5.svg";